import { render, staticRenderFns } from "./states-province-selector.vue?vue&type=template&id=281f6e26"
import script from "./states-province-selector.vue?vue&type=script&lang=js"
export * from "./states-province-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports